import React from "react";

import styles from "./SwitchButton.module.css";

class SwitchButton extends React.Component {
  render() {
    //button width should be equal to the width of button, and it will be required so slider can travel according to that
    const { containerStyle, buttonStyle, labelStyle, buttonWidth } = this.props;
    // Merge styles passed through props with inline styles
    const mergedButtonStyle = {
      "--buttonWidth": buttonWidth ? buttonWidth : "clamp(180px, 26vh, 270px)",
      ...buttonStyle,
    };

    return (
      <div className={styles.inputDiv} style={containerStyle}>
        <label className={styles.toggle} style={mergedButtonStyle}>
          <input
            type="checkbox"
            checked={this.props.buttonState}
            onChange={this.props.onClick}
          />

          <span className={styles.slider}></span>
          <span
            className={styles.switchText}
            style={labelStyle}
            data-on={this.props.option2}
            data-off={this.props.option1}
          ></span>
          {this.props.highlightText && (
            <span className={styles.highlightedText}>
              {this.props.highlightText}
            </span>
          )}
        </label>
      </div>
    );
  }
}

export default SwitchButton;
